package dairy.mynotes.reusablecomponents

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.ButtonColors
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import dairy.mynotes.ui.theme.AppColors

@Composable
fun ButtonComponent(
    text: String,
    enabled:Boolean = true,
    defaultRoundedCornerRadius: Dp = 12.dp,
    modifier: androidx.compose.ui.Modifier = androidx.compose.ui.Modifier,
    colors: ButtonColors = androidx.compose.material3.ButtonDefaults.buttonColors(),
    textColor: androidx.compose.ui.graphics.Color = AppColors.Background,
    onClick: () -> Unit,
) {
    androidx.compose.material3.Button(
        onClick = onClick,
        modifier = modifier,
        colors = colors,
        enabled = enabled,
        shape = RoundedCornerShape(defaultRoundedCornerRadius)
    ) {
        Label(text = text,
            color = textColor,
            textStyle = androidx.compose.material3.MaterialTheme.typography.bodyLarge)
    }
}